
import { defineComponent, getCurrentInstance, onMounted, PropType } from 'vue';
import { getQuery, checkSeoReferrer } from '@/common/utils';

export default defineComponent({
  components: {

  },
  props: {
    userName: {
      type: String,
      required: true,
      default: ''
    }
  },
  setup(props, ctx) {
    const { proxy } = getCurrentInstance() as { proxy: Vue };

    const handleShareClick = () => {
      ctx.emit('share', { type: 'share' })
    }
    const handleBackClick = () => {
      // if (checkSeoReferrer()) {
      //   const query = getQuery()
      //   proxy.$router.push({ path: '/foryou', query: { ...query, page_source: 'guest_profile' } });
      // } else {
      window.history.back()
      // }
    }

    return {
      proxy,
      handleShareClick,
      handleBackClick,
    };
  },

});

